import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=5e2e8ba5"
import script from "./SiteLayout.vue?vue&type=script&lang=js"
export * from "./SiteLayout.vue?vue&type=script&lang=js"
import style0 from "./SiteLayout.vue?vue&type=style&index=0&id=5e2e8ba5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports